import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Button, Space } from 'antd';

import retornar from '../../assets/icons/iconBackRelatorios.svg';
import colors from '../../styles/colors';
import * as S from './styles';

export function SubHeader() {
  const history = useHistory();

  return (
    <Row
      justify="space-between"
      align="middle"
      style={{ margin: '0 6px 0 6px' }}
    >
      <S.Title color={colors.blue} size={32} weight>
        Migração
      </S.Title>
      <Button
        type="primary"
        style={{
          border: 'none',
          backgroundColor: '#24A95D',
          textAlign: 'center',
          width: 107,
          height: 45,
        }}
        onClick={() => history.push('/painel-de-controle')}
      >
        <Space
          style={{
            width: '70%',
            justifyContent: 'space-evenly',
            justifyItems: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            padding: 0,
            border: 'none',
          }}
        >
          <img src={retornar} alt="retornar" />
          Voltar
        </Space>
      </Button>
    </Row>
  );
}
